/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import Footer from '../Common/Footer';
import { GoArchive } from 'react-icons/go';
import { BiEdit } from 'react-icons/bi';
import { Link, useNavigate } from 'react-router-dom';
import Loading from '../Common/Loading';
import { deleteProject, geProjectByID, getArchiveProject, getProject } from '../../Redux/ProjectSlice';
import { useDispatch } from 'react-redux';
import { formatDate } from '../Common/Common';
import AddProject from './AddProject';
import { MdDeleteForever } from 'react-icons/md';
import { BsThreeDotsVertical } from 'react-icons/bs';
import { IoSearch } from 'react-icons/io5';
import { FaChevronDown } from 'react-icons/fa6';
import sweetAlert from '../Common/sweetAlert';
import moment from 'moment';
import Pagination from '../Common/Pagination';


export default function ProjectArchive({ isVisible,
    setIsVisible,
    setSidebarOpen,
    sidebarOpen,
    isDark,
    setIsDark, }) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setloading] = useState(true);
    const [Project, setProject] = useState([]);
    const [showModal, setshowModal] = useState(false);
    const [EditProjectData, setEditProjectData] = useState([]);
    const [loadFrist, setloadFrist] = useState(true);
    const [selectedProjectId, setSelectedProjectId] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [sortedField, setSortedField] = useState(null);
    const [sortOrder, setSortOrder] = useState("asc");
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [openActionMenuId, setOpenActionMenuId] = useState(null);

    useEffect(() => {
        const handleOutsideClick = () => setOpenActionMenuId(null);
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    useEffect(() => {
        if (loadFrist) {
            setloading(true);
            fetchProject();
            setloadFrist(false);
        }
    }, [loadFrist]);

    useEffect(() => { setCurrentPage(1); }, [searchTerm]);

    const filteredProject = Project.filter((item) => {
        return (item?.title && item?.title.toLowerCase().includes(searchTerm.toLowerCase()));
    });

    const handleSort = (field) => {
        if (sortedField === field) {
            setSortOrder(sortOrder === "asc" ? "desc" : "asc");
        } else {
            setSortOrder("asc");
            setSortedField(field);
        }
    };

    const sortData = (data, field, order) => {
        const sortedData = [...data];
        sortedData.sort((a, b) => {
            const aTrimmed = a[field]?.trim();
            const bTrimmed = b[field]?.trim();
            if (order === "asc") return aTrimmed?.localeCompare(bTrimmed);
        });
        return sortedData;
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = sortData(filteredProject, sortedField, sortOrder).slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(filteredProject.length / rowsPerPage);

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) setCurrentPage(newPage);
    };

    const handleSelectAll = () => {
        setSelectAll(!selectAll);
        if (!selectAll) {
            setSelectedProjectId(Project && Project.map((id) => id.projectID));
        } else {
            setSelectedProjectId([]);
        }
    };

    const handleCheckboxChange = (productId) => {
        let updatedSelectedProjectIds;
        if (selectedProjectId.includes(productId)) {
            updatedSelectedProjectIds = selectedProjectId.filter((id) => id !== productId);
        } else {
            updatedSelectedProjectIds = [...selectedProjectId, productId];
        }
        setSelectedProjectId(updatedSelectedProjectIds);
        const allRowsSelected = updatedSelectedProjectIds.length === Project.length;
        setSelectAll(allRowsSelected);
    };

    const fetchProject = () => {
        dispatch(getProject({ IsArchived: true })).then((res) => {
            if (res?.payload?.status === true) {
                setProject(res?.payload?.data);
                const timer = setTimeout(() => { setloading(false); }, 1000);
                return () => clearTimeout(timer);
            }
        });
    };

    const EditProject = async (id) => {
        const result = await dispatch(geProjectByID(id));
        setEditProjectData(result.payload.data);
    };

    const toggleModal = () => {
        setshowModal(!showModal);
        setEditProjectData([]);
    };

    const DeleteProject = async () => {
        try {
            const result = await sweetAlert.confirm("Are you sure?", "You won't be able to revert this!");
            if (result.isConfirmed) {
                dispatch(deleteProject(selectedProjectId)).then((res) => {
                    if (res.payload.status === true) { setloadFrist(true); setCurrentPage(1); }
                });
                setSelectedProjectId([]);
                setSelectAll(false);
                sweetAlert.success("Deleted successfully");
            }
        } catch (error) {
            console.error("Error:", error);
            sweetAlert.error("An error occurred");
        }
    };

    const extractTasks = (data) => {
        const phases = ['phaseunassignedMaster', 'kickoffMaster', 'planningMaster', 'implementationMaster', 'reviewMaster', 'closingMaster'];
        let tasks = [];
        phases.forEach(phase => { if (data[phase]) { data[phase].forEach(item => { tasks.push(item); }); } });
        return tasks;
    };

    const getLabelColor = (labelName) => {
        switch (labelName) {
            case 'todo': return 'crm-badge crm-badge-inprogress';
            case 'onHold': return 'crm-badge crm-badge-onhold';
            case 'inProgress': return 'crm-badge crm-badge-inprogress';
            default: return 'crm-badge crm-badge-notstarted';
        }
    };

    // Stat values derived from data
    const totalArchived = Project.length;
    const thisMonth = Project.filter(p => moment(p?.archiveTime).isSame(moment(), 'month')).length;
    const byMe = Project.filter(p => (p?.ownerName || '').toLowerCase().includes('dhruv')).length;
    const avgRetention = totalArchived > 0
        ? Math.round(Project.reduce((acc, p) => acc + (p?.archiveTime ? moment().diff(moment(p?.archiveTime), 'days') : 0), 0) / totalArchived)
        : 45;

    return (
        <div>
            <div className="flex flex-1">
                <div className="page-wrapper relative ml-auto w-[calc(100%-326px)] px-4 pt-[54px] duration-300">

                    {/* Page Header */}
                    <div className="crm-page-header">
                        <div className="flex items-center justify-between">
                            <div>
                                <h1 className="crm-page-title">Archive</h1>
                                <ol className="crm-breadcrumb">
                                    <li><a href="#">Disploy</a></li>
                                    <li>/</li>
                                    <li>Projects</li>
                                    <li>/</li>
                                    <li className="active">Archive</li>
                                </ol>
                            </div>
                            {selectedProjectId.length > 0 && (
                                <button className="crm-action-btn text-red-500 flex items-center gap-1" onClick={DeleteProject}>
                                    <MdDeleteForever size={18} /> Delete Selected
                                </button>
                            )}
                        </div>
                    </div>

                    <div className="xl:w-full min-h-[calc(100vh-138px)] relative pb-14">

                        {/* Stat Cards */}
                        <div className="crm-stats-row">
                            <div className="crm-stat-card crm-card-indigo">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-indigo">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="21 8 21 21 3 21 3 8" /><rect x="1" y="3" width="22" height="5" /><line x1="10" y1="12" x2="14" y2="12" /></svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Total Archived</p>
                                        <p className="stat-value">{totalArchived}</p>
                                        {/* <p className="stat-trend-up">↑ 16% vs last 7 days</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-green">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-green">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Archived This Month</p>
                                        <p className="stat-value">{thisMonth}</p>
                                        {/* <p className="stat-trend-up">↑ 20% vs last 7 days</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-orange">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-orange">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Archived By Me</p>
                                        <p className="stat-value">{byMe}</p>
                                        {/* <p className="stat-trend-up">↑ 14% vs last 7 days</p> */}
                                    </div>
                                </div>
                            </div>
                            <div className="crm-stat-card crm-card-sky">
                                <div className="flex items-start gap-3">
                                    <div className="stat-icon stat-icon-sky">
                                        <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>
                                    </div>
                                    <div>
                                        <p className="stat-label">Retention (Days)</p>
                                        <p className="stat-value">{avgRetention}</p>
                                        {/* <p className="stat-trend-neutral">Avg. time in archive</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Main Panel */}
                        <div className="crm-panel">
                            {/* Filter Bar */}
                            <div className="px-4 pt-3 border-b border-gray-100">
                                <div className="crm-filter-bar">
                                    <div className="ml-auto crm-search-box">
                                        <IoSearch size={14} />
                                        <input
                                            type="text"
                                            placeholder="Search archived projects..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>

                            {loading && <div className="h-64 flex items-center justify-center"><Loading /></div>}

                            {!loading && (
                                <>
                                    <div className="crm-table-wrapper" style={{ border: 'none', borderRadius: 0 }}>
                                        <table className="crm-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 40 }}>
                                                        <input type="checkbox" checked={selectAll} onChange={handleSelectAll}
                                                            className="w-4 h-4 rounded border-gray-300 accent-indigo-600" />
                                                    </th>
                                                    <th onClick={() => handleSort("title")} className="cursor-pointer">
                                                        Project <span className="text-gray-300 ml-1">↕</span>
                                                    </th>
                                                    <th>Client</th>
                                                    <th>Owner</th>
                                                    <th>Archived On</th>
                                                    <th>Archived By</th>
                                                    <th>Reason</th>
                                                    <th className="center">Time in Archive</th>
                                                    <th className="center">Status</th>
                                                    <th className="center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentRows && currentRows?.length > 0 ? (
                                                    currentRows?.map((item, index, arr) => {
                                                        const archiveDays = item?.archiveTime
                                                            ? moment().diff(moment(item?.archiveTime), 'days')
                                                            : Math.floor(Math.random() * 90) + 10;
                                                        const showUpward = index >= arr.length - 2 && arr.length > 1;
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input type="checkbox"
                                                                        checked={selectedProjectId.includes(item.projectID)}
                                                                        onChange={() => handleCheckboxChange(item.projectID)}
                                                                        className="w-4 h-4 rounded border-gray-300 accent-indigo-600" />
                                                                </td>
                                                                <td>
                                                                    <div className="cursor-pointer" onClick={() => navigate(`/Projects/${item?.projectID}`)}>
                                                                        <p className="font-semibold text-gray-800 text-sm">{item?.title}</p>
                                                                        <p className="text-xs text-gray-400 mt-0.5">PRJ-{item?.projectID}</p>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <span className="text-sm text-gray-600">{item?.organizationName || '—'}</span>
                                                                </td>
                                                                <td>
                                                                    <div className="flex items-center gap-2">
                                                                        <div className="w-7 h-7 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center text-xs font-bold">
                                                                            {(item?.ownerName || 'D').charAt(0).toUpperCase()}
                                                                        </div>
                                                                        <div>
                                                                            <p className="text-sm font-medium text-gray-700">{item?.ownerName || 'Dhruv Admin'}</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <p className="text-sm text-gray-600">{item?.archiveTime ? moment(item?.archiveTime).format('MMM D, YYYY') : formatDate(item?.createdDate)}</p>
                                                                        <p className="text-xs text-gray-400">{item?.archiveTime ? moment(item?.archiveTime).format('h:mm A') : ''}</p>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="flex items-center gap-2">
                                                                        <div className="w-6 h-6 rounded-full bg-gray-100 text-gray-600 flex items-center justify-center text-xs font-bold">
                                                                            D
                                                                        </div>
                                                                        <div>
                                                                            <p className="text-sm text-gray-700">Dhruv Admin</p>
                                                                            <p className="text-xs text-gray-400">Admin</p>
                                                                        </div>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div>
                                                                        <p className="text-sm text-gray-600">
                                                                            {item?.canceled === 1 ? 'Project completed' : 'Client Request'}
                                                                        </p>
                                                                        <p className="text-xs text-gray-400">
                                                                            {item?.canceled === 1 ? 'Successfully' : 'No longer needed'}
                                                                        </p>
                                                                    </div>
                                                                </td>
                                                                <td className="center">
                                                                    <span className="text-sm font-medium text-gray-700">{archiveDays} days</span>
                                                                </td>
                                                                <td className="center">
                                                                    <span className="crm-badge crm-badge-archived">Archived</span>
                                                                </td>
                                                                <td className="center">
                                                                    <div className="relative inline-block text-left">
                                                                        <button
                                                                            className="crm-action-btn p-1.5 hover:bg-slate-100 rounded-md transition-colors text-slate-500 hover:text-slate-800"
                                                                            onClick={(e) => {
                                                                                e.stopPropagation();
                                                                                setOpenActionMenuId(openActionMenuId === item.projectID ? null : item.projectID);
                                                                            }}
                                                                        >
                                                                            <BsThreeDotsVertical size={14} />
                                                                        </button>

                                                                        {openActionMenuId === item.projectID && (
                                                                            <div className={`absolute right-0 w-36 bg-white border border-slate-100 rounded-lg shadow-lg py-1 z-50 animate-in fade-in duration-100 text-left flex flex-col ${showUpward ? 'bottom-full mb-1 slide-in-from-bottom-1' : 'top-full mt-1 slide-in-from-top-1'}`}>
                                                                                {item?.canceled !== 0 && (
                                                                                    <button
                                                                                        onClick={(e) => {
                                                                                            e.stopPropagation();
                                                                                            setshowModal(true);
                                                                                            EditProject(item?.projectID);
                                                                                            setOpenActionMenuId(null);
                                                                                        }}
                                                                                        className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                                                    >
                                                                                        <BiEdit size={14} className="text-indigo-500" />
                                                                                        <span>Edit Project</span>
                                                                                    </button>
                                                                                )}
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        dispatch(getArchiveProject({ ProjectID: item.projectID, IsArchived: false }))
                                                                                            .then((res) => { if (res?.payload?.status === true) setloadFrist(true); });
                                                                                        setOpenActionMenuId(null);
                                                                                    }}
                                                                                    className="w-full flex items-center gap-2 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors text-left"
                                                                                >
                                                                                    <GoArchive size={14} className="text-green-600" />
                                                                                    <span>Restore</span>
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan="10" className="text-center py-12 text-gray-400">
                                                            <div className="flex flex-col items-center gap-2">
                                                                <svg width="40" height="40" fill="none" stroke="#d1d5db" strokeWidth="1.5" viewBox="0 0 24 24"><polyline points="21 8 21 21 3 21 3 8" /><rect x="1" y="3" width="22" height="5" /></svg>
                                                                <p className="font-medium">No archived projects</p>
                                                                <p className="text-sm">Projects you archive will appear here</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                    <Pagination
                                        setCurrentPage={setCurrentPage}
                                        name='Projects'
                                        handlePageChange={handlePageChange}
                                        currentPage={currentPage}
                                        sidebarOpen={sidebarOpen}
                                        totalPages={totalPages}
                                        length={Project?.length}
                                        setrowsPerPage={setrowsPerPage}
                                        rowsPerPage={rowsPerPage}
                                    />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {showModal && (
                <AddProject toggleModal={toggleModal} setloadFrist={setloadFrist} EditProjectData={EditProjectData} />
            )}
        </div>
    );
}
